export class CustomerConfig {
  collectNationalNumber?: boolean;
  enableEidReader?: boolean;

  constructor() {
    this.collectNationalNumber = false;
    this.enableEidReader = false;
  }
}
